import React from "react";
import CardlessEMITenure from "../CardlessEMITenure";
import EmiPlanSelection from "./EmiPlanSelection";
import "../style.css";

function BankDetails({
  selectedBank,
  isProceedDisable,
  onProceed,
  hdfcEtbTenures = [],
  iciciEtbTenures = [],
  panNumber,
  setPanNumber,
  selectedTenure,
  setselectedTenure,
  checkPanCardEligible,
  submitButtonClicked,
  panCardInputErrorMessage,
  panCardErrorMessage,
  clearCheckEligibilityForCardlessEMIAction,
  merchantPaymentData,
  dcEMIIssuer,
  iciciDcEMIIssuer,
}) {
  if (!selectedBank?.name) return null;

  const bankName = selectedBank.name;
  const isAxio = bankName === "AXIO";
  const isHDFC_ETB = bankName === "HDFC_ETB";
  const isICICI = bankName === "ICICI";

  const redirectToPartnerMessage = selectedBank.existing_customer
    ? "You will be redirected to the partner's page."
    : "You will be redirected to the partner's page to sign-up.";

  return (
    <div className="cardless-emi-tenure">
      {isAxio ? (
        <div>
          <h2>{redirectToPartnerMessage}</h2>
          <button
            className={`btn btn-green col-3 ${
              isProceedDisable ? "disable" : ""
            }`}
            onClick={(e) => {
              if (!isProceedDisable) {
                onProceed(e);
              }
            }}
          >
            Proceed
          </button>
        </div>
      ) : isHDFC_ETB ? (
        hdfcEtbTenures?.length > 0 ? (
          <EmiPlanSelection
            tenures={hdfcEtbTenures}
            showTenures={true}
            bankName="HDFC"
            panLength={5}
            panPlaceholder="Enter last “5 characters” of your PAN (e.g. for PAN ABCDF1234G enter “1234G”)"
            {...{
              panNumber,
              setPanNumber,
              selectedTenure,
              setselectedTenure,
              checkPanCardEligible,
              submitButtonClicked,
              panCardInputErrorMessage,
              merchantPaymentData,
              bankData: dcEMIIssuer,
            }}
          />
        ) : (
          <div className="error-text not-eligible-text">
            No EMI Plan is available. Please re-try with other cardless issuers.
          </div>
        )
      ) : isICICI ? (
        iciciEtbTenures?.length > 0 ? (
          <EmiPlanSelection
            tenures={iciciEtbTenures}
            showTenures={true}
            bankName="ICICI"
            panLength={10}
            panPlaceholder="Enter your PAN"
            {...{
              panNumber,
              setPanNumber,
              selectedTenure,
              setselectedTenure,
              checkPanCardEligible,
              submitButtonClicked,
              panCardInputErrorMessage,
              merchantPaymentData,
              bankData: iciciDcEMIIssuer,
            }}
          />
        ) : (
          <div className="error-text not-eligible-text">
            No EMI Plan is available. Please re-try with other cardless issuers.
          </div>
        )
      ) : (
        <div>
          <h3 className="title-green">
            Select EMI plan for {selectedBank.name}
          </h3>
          <div className="tenure-list">
            {selectedBank.emi_data.map((tenure) => (
              <CardlessEMITenure
                tenure={tenure}
                selectedTenure={selectedTenure}
                setselectedTenure={setselectedTenure}
                key={`cardless-emi-tenure-${tenure.tenure}`}
                onTenureProceed={onProceed}
              />
            ))}
          </div>
        </div>
      )}
      {panCardErrorMessage && (
        <div className="error-text not-eligible-text">
          {panCardErrorMessage}Please re-try with other Cardless issuers or if
          you wish to change mobile number please{" "}
          <span
            style={{ cursor: "pointer" }}
            className="btn-link"
            onClick={clearCheckEligibilityForCardlessEMIAction}
          >
            click here
          </span>
        </div>
      )}
    </div>
  );
}

export default BankDetails;
